export const DATE_FORMAT = 'YYYY-MM-DD'

export const ACTIVE_INACTIVE_OPTIONS = [
  { text: 'All', value: 'All' },
  { text: 'Active', value: 'Active' },
  { text: 'Inactive', value: 'Inactive' }
]

export const YES_NO_OPTIONS = [
  { text: 'Yes', value: true },
  { text: 'No', value: false }
]

export const KEEP_AS_IS_VALUE = 'keep_as_is';
export const KEEP_AS_IS_OPTION = { text: 'Keep as is', value: KEEP_AS_IS_VALUE };

export const CASH_CALL_REASON_OPTIONS = [
  { text: 'BDX replenishment overdue', value: 'BDX replenishment overdue' },
  { text: 'Large Loss', value: 'Large Loss' },
  { text: 'Loss fund not set up', value: 'Loss fund not set up' },
  { text: 'Loss fund level too low', value: 'Loss fund level too low' },
  { text: 'Other (please specify)', value: 'Other' },
]

export const CASH_CALL_AUTHORITY_SCOPE_OPTIONS = [
  { text: 'Within Authority', value: 'Within Authority' },
  { text: 'Outside Authority', value: 'Outside Authority' }
]

export const CASH_CALL_SUPPORTING_DOCUMENT_OPTIONS = [
  { text: 'Adjuster Report', value: 'Adjuster Report' },
  { text: 'Policy Including Certificate', value: 'Policy Including Certificate' },
  { text: 'TPA Report including cash call amount', value: 'TPA Report including cash call amount' },
  { text: 'Estimate', value: 'Estimate' },
  { text: 'Photos', value: 'Photos' },
  { text: 'Weather / Fire / Police Report', value: 'Weather / Fire / Police Report' },
  { text: 'Engineer / Expert Report', value: 'Engineer / Expert Report' },
  { text: 'Sanction Check', value: 'Sanction Check' },
]

// LIQ-1154: file types allowed on the Documentation step. Keep in sync with
// SUPPORTING_DOC_EXTENSIONS in project/cash_call/views.py.
export const CASH_CALL_SUPPORTING_DOCUMENT_EXTENSIONS = [
  '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.csv', '.png', '.jpg', '.jpeg'
]

export const CASH_CALL_CLAIM_COUNTRY_OPTIONS = [
  { text: 'USA', value: 'USA' },
  { text: 'UK', value: 'UK' },
  { text: 'Canada', value: 'Canada' }
]

// Full world country list for the CO-LEAD claim country dropdown only. The
// normal cash call keeps CASH_CALL_CLAIM_COUNTRY_OPTIONS (USA/UK/Canada), which
// drives its state/province-specific fields; co-lead step 3 has no such fields,
// so it can accept any country. USA/UK/Canada are surfaced first for quick
// access, then the rest alphabetically.
export const CASH_CALL_COLEAD_COUNTRY_OPTIONS = [
  { text: 'USA', value: 'USA' },
  { text: 'UK', value: 'UK' },
  { text: 'Canada', value: 'Canada' },
  { text: 'Afghanistan', value: 'Afghanistan' },
  { text: 'Albania', value: 'Albania' },
  { text: 'Algeria', value: 'Algeria' },
  { text: 'Andorra', value: 'Andorra' },
  { text: 'Angola', value: 'Angola' },
  { text: 'Antigua and Barbuda', value: 'Antigua and Barbuda' },
  { text: 'Argentina', value: 'Argentina' },
  { text: 'Armenia', value: 'Armenia' },
  { text: 'Australia', value: 'Australia' },
  { text: 'Austria', value: 'Austria' },
  { text: 'Azerbaijan', value: 'Azerbaijan' },
  { text: 'Bahamas', value: 'Bahamas' },
  { text: 'Bahrain', value: 'Bahrain' },
  { text: 'Bangladesh', value: 'Bangladesh' },
  { text: 'Barbados', value: 'Barbados' },
  { text: 'Belarus', value: 'Belarus' },
  { text: 'Belgium', value: 'Belgium' },
  { text: 'Belize', value: 'Belize' },
  { text: 'Benin', value: 'Benin' },
  { text: 'Bhutan', value: 'Bhutan' },
  { text: 'Bolivia', value: 'Bolivia' },
  { text: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina' },
  { text: 'Botswana', value: 'Botswana' },
  { text: 'Brazil', value: 'Brazil' },
  { text: 'Brunei', value: 'Brunei' },
  { text: 'Bulgaria', value: 'Bulgaria' },
  { text: 'Burkina Faso', value: 'Burkina Faso' },
  { text: 'Burundi', value: 'Burundi' },
  { text: 'Cabo Verde', value: 'Cabo Verde' },
  { text: 'Cambodia', value: 'Cambodia' },
  { text: 'Cameroon', value: 'Cameroon' },
  { text: 'Central African Republic', value: 'Central African Republic' },
  { text: 'Chad', value: 'Chad' },
  { text: 'Chile', value: 'Chile' },
  { text: 'China', value: 'China' },
  { text: 'Colombia', value: 'Colombia' },
  { text: 'Comoros', value: 'Comoros' },
  { text: 'Congo (Brazzaville)', value: 'Congo (Brazzaville)' },
  { text: 'Congo (Kinshasa)', value: 'Congo (Kinshasa)' },
  { text: 'Costa Rica', value: 'Costa Rica' },
  { text: "Cote d'Ivoire", value: "Cote d'Ivoire" },
  { text: 'Croatia', value: 'Croatia' },
  { text: 'Cuba', value: 'Cuba' },
  { text: 'Cyprus', value: 'Cyprus' },
  { text: 'Czechia', value: 'Czechia' },
  { text: 'Denmark', value: 'Denmark' },
  { text: 'Djibouti', value: 'Djibouti' },
  { text: 'Dominica', value: 'Dominica' },
  { text: 'Dominican Republic', value: 'Dominican Republic' },
  { text: 'Ecuador', value: 'Ecuador' },
  { text: 'Egypt', value: 'Egypt' },
  { text: 'El Salvador', value: 'El Salvador' },
  { text: 'Equatorial Guinea', value: 'Equatorial Guinea' },
  { text: 'Eritrea', value: 'Eritrea' },
  { text: 'Estonia', value: 'Estonia' },
  { text: 'Eswatini', value: 'Eswatini' },
  { text: 'Ethiopia', value: 'Ethiopia' },
  { text: 'Fiji', value: 'Fiji' },
  { text: 'Finland', value: 'Finland' },
  { text: 'France', value: 'France' },
  { text: 'Gabon', value: 'Gabon' },
  { text: 'Gambia', value: 'Gambia' },
  { text: 'Georgia', value: 'Georgia' },
  { text: 'Germany', value: 'Germany' },
  { text: 'Ghana', value: 'Ghana' },
  { text: 'Greece', value: 'Greece' },
  { text: 'Grenada', value: 'Grenada' },
  { text: 'Guatemala', value: 'Guatemala' },
  { text: 'Guinea', value: 'Guinea' },
  { text: 'Guinea-Bissau', value: 'Guinea-Bissau' },
  { text: 'Guyana', value: 'Guyana' },
  { text: 'Haiti', value: 'Haiti' },
  { text: 'Honduras', value: 'Honduras' },
  { text: 'Hungary', value: 'Hungary' },
  { text: 'Iceland', value: 'Iceland' },
  { text: 'India', value: 'India' },
  { text: 'Indonesia', value: 'Indonesia' },
  { text: 'Iran', value: 'Iran' },
  { text: 'Iraq', value: 'Iraq' },
  { text: 'Ireland', value: 'Ireland' },
  { text: 'Israel', value: 'Israel' },
  { text: 'Italy', value: 'Italy' },
  { text: 'Jamaica', value: 'Jamaica' },
  { text: 'Japan', value: 'Japan' },
  { text: 'Jordan', value: 'Jordan' },
  { text: 'Kazakhstan', value: 'Kazakhstan' },
  { text: 'Kenya', value: 'Kenya' },
  { text: 'Kiribati', value: 'Kiribati' },
  { text: 'Kuwait', value: 'Kuwait' },
  { text: 'Kyrgyzstan', value: 'Kyrgyzstan' },
  { text: 'Laos', value: 'Laos' },
  { text: 'Latvia', value: 'Latvia' },
  { text: 'Lebanon', value: 'Lebanon' },
  { text: 'Lesotho', value: 'Lesotho' },
  { text: 'Liberia', value: 'Liberia' },
  { text: 'Libya', value: 'Libya' },
  { text: 'Liechtenstein', value: 'Liechtenstein' },
  { text: 'Lithuania', value: 'Lithuania' },
  { text: 'Luxembourg', value: 'Luxembourg' },
  { text: 'Madagascar', value: 'Madagascar' },
  { text: 'Malawi', value: 'Malawi' },
  { text: 'Malaysia', value: 'Malaysia' },
  { text: 'Maldives', value: 'Maldives' },
  { text: 'Mali', value: 'Mali' },
  { text: 'Malta', value: 'Malta' },
  { text: 'Marshall Islands', value: 'Marshall Islands' },
  { text: 'Mauritania', value: 'Mauritania' },
  { text: 'Mauritius', value: 'Mauritius' },
  { text: 'Mexico', value: 'Mexico' },
  { text: 'Micronesia', value: 'Micronesia' },
  { text: 'Moldova', value: 'Moldova' },
  { text: 'Monaco', value: 'Monaco' },
  { text: 'Mongolia', value: 'Mongolia' },
  { text: 'Montenegro', value: 'Montenegro' },
  { text: 'Morocco', value: 'Morocco' },
  { text: 'Mozambique', value: 'Mozambique' },
  { text: 'Myanmar', value: 'Myanmar' },
  { text: 'Namibia', value: 'Namibia' },
  { text: 'Nauru', value: 'Nauru' },
  { text: 'Nepal', value: 'Nepal' },
  { text: 'Netherlands', value: 'Netherlands' },
  { text: 'New Zealand', value: 'New Zealand' },
  { text: 'Nicaragua', value: 'Nicaragua' },
  { text: 'Niger', value: 'Niger' },
  { text: 'Nigeria', value: 'Nigeria' },
  { text: 'North Korea', value: 'North Korea' },
  { text: 'North Macedonia', value: 'North Macedonia' },
  { text: 'Norway', value: 'Norway' },
  { text: 'Oman', value: 'Oman' },
  { text: 'Pakistan', value: 'Pakistan' },
  { text: 'Palau', value: 'Palau' },
  { text: 'Palestine', value: 'Palestine' },
  { text: 'Panama', value: 'Panama' },
  { text: 'Papua New Guinea', value: 'Papua New Guinea' },
  { text: 'Paraguay', value: 'Paraguay' },
  { text: 'Peru', value: 'Peru' },
  { text: 'Philippines', value: 'Philippines' },
  { text: 'Poland', value: 'Poland' },
  { text: 'Portugal', value: 'Portugal' },
  { text: 'Qatar', value: 'Qatar' },
  { text: 'Romania', value: 'Romania' },
  { text: 'Russia', value: 'Russia' },
  { text: 'Rwanda', value: 'Rwanda' },
  { text: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis' },
  { text: 'Saint Lucia', value: 'Saint Lucia' },
  { text: 'Saint Vincent and the Grenadines', value: 'Saint Vincent and the Grenadines' },
  { text: 'Samoa', value: 'Samoa' },
  { text: 'San Marino', value: 'San Marino' },
  { text: 'Sao Tome and Principe', value: 'Sao Tome and Principe' },
  { text: 'Saudi Arabia', value: 'Saudi Arabia' },
  { text: 'Senegal', value: 'Senegal' },
  { text: 'Serbia', value: 'Serbia' },
  { text: 'Seychelles', value: 'Seychelles' },
  { text: 'Sierra Leone', value: 'Sierra Leone' },
  { text: 'Singapore', value: 'Singapore' },
  { text: 'Slovakia', value: 'Slovakia' },
  { text: 'Slovenia', value: 'Slovenia' },
  { text: 'Solomon Islands', value: 'Solomon Islands' },
  { text: 'Somalia', value: 'Somalia' },
  { text: 'South Africa', value: 'South Africa' },
  { text: 'South Korea', value: 'South Korea' },
  { text: 'South Sudan', value: 'South Sudan' },
  { text: 'Spain', value: 'Spain' },
  { text: 'Sri Lanka', value: 'Sri Lanka' },
  { text: 'Sudan', value: 'Sudan' },
  { text: 'Suriname', value: 'Suriname' },
  { text: 'Sweden', value: 'Sweden' },
  { text: 'Switzerland', value: 'Switzerland' },
  { text: 'Syria', value: 'Syria' },
  { text: 'Taiwan', value: 'Taiwan' },
  { text: 'Tajikistan', value: 'Tajikistan' },
  { text: 'Tanzania', value: 'Tanzania' },
  { text: 'Thailand', value: 'Thailand' },
  { text: 'Timor-Leste', value: 'Timor-Leste' },
  { text: 'Togo', value: 'Togo' },
  { text: 'Tonga', value: 'Tonga' },
  { text: 'Trinidad and Tobago', value: 'Trinidad and Tobago' },
  { text: 'Tunisia', value: 'Tunisia' },
  { text: 'Turkey', value: 'Turkey' },
  { text: 'Turkmenistan', value: 'Turkmenistan' },
  { text: 'Tuvalu', value: 'Tuvalu' },
  { text: 'Uganda', value: 'Uganda' },
  { text: 'Ukraine', value: 'Ukraine' },
  { text: 'United Arab Emirates', value: 'United Arab Emirates' },
  { text: 'Uruguay', value: 'Uruguay' },
  { text: 'Uzbekistan', value: 'Uzbekistan' },
  { text: 'Vanuatu', value: 'Vanuatu' },
  { text: 'Vatican City', value: 'Vatican City' },
  { text: 'Venezuela', value: 'Venezuela' },
  { text: 'Vietnam', value: 'Vietnam' },
  { text: 'Yemen', value: 'Yemen' },
  { text: 'Zambia', value: 'Zambia' },
  { text: 'Zimbabwe', value: 'Zimbabwe' },
]

export const CASH_CALL_CLAIM_STATE_OPTIONS = [
  { text: 'AL', value: 'AL' },
  { text: 'AK', value: 'AK' },
  { text: 'AZ', value: 'AZ' },
  { text: 'AR', value: 'AR' },
  { text: 'CA', value: 'CA' },
  { text: 'CO', value: 'CO' },
  { text: 'CT', value: 'CT' },
  { text: 'DE', value: 'DE' },
  { text: 'DC', value: 'DC' },
  { text: 'FL', value: 'FL' },
  { text: 'GA', value: 'GA' },
  { text: 'HI', value: 'HI' },
  { text: 'ID', value: 'ID' },
  { text: 'IL', value: 'IL' },
  { text: 'IN', value: 'IN' },
  { text: 'IA', value: 'IA' },
  { text: 'KS', value: 'KS' },
  { text: 'KY', value: 'KY' },
  { text: 'LA', value: 'LA' },
  { text: 'ME', value: 'ME' },
  { text: 'MD', value: 'MD' },
  { text: 'MA', value: 'MA' },
  { text: 'MI', value: 'MI' },
  { text: 'MN', value: 'MN' },
  { text: 'MS', value: 'MS' },
  { text: 'MO', value: 'MO' },
  { text: 'MT', value: 'MT' },
  { text: 'NE', value: 'NE' },
  { text: 'NV', value: 'NV' },
  { text: 'NH', value: 'NH' },
  { text: 'NJ', value: 'NJ' },
  { text: 'NM', value: 'NM' },
  { text: 'NY', value: 'NY' },
  { text: 'NC', value: 'NC' },
  { text: 'ND', value: 'ND' },
  { text: 'OH', value: 'OH' },
  { text: 'OK', value: 'OK' },
  { text: 'OR', value: 'OR' },
  { text: 'PA', value: 'PA' },
  { text: 'RI', value: 'RI' },
  { text: 'SC', value: 'SC' },
  { text: 'SD', value: 'SD' },
  { text: 'TN', value: 'TN' },
  { text: 'TX', value: 'TX' },
  { text: 'UT', value: 'UT' },
  { text: 'VT', value: 'VT' },
  { text: 'VA', value: 'VA' },
  { text: 'WA', value: 'WA' },
  { text: 'WV', value: 'WV' },
  { text: 'WI', value: 'WI' },
  { text: 'WY', value: 'WY' }
]

export const CASH_CALL_SL_TAX_STATE_OPTIONS = [
  { text: 'AL', value: 'AL' },
  { text: 'AK', value: 'AK' },
  { text: 'AZ', value: 'AZ' },
  { text: 'AR', value: 'AR' },
  { text: 'CA', value: 'CA' },
  { text: 'CO', value: 'CO' },
  { text: 'CT', value: 'CT' },
  { text: 'DE', value: 'DE' },
  { text: 'DC', value: 'DC' },
  { text: 'FL', value: 'FL' },
  { text: 'GA', value: 'GA' },
  { text: 'HI', value: 'HI' },
  { text: 'ID', value: 'ID' },
  { text: 'IL', value: 'IL' },
  { text: 'IN', value: 'IN' },
  { text: 'IA', value: 'IA' },
  { text: 'KS', value: 'KS' },
  { text: 'KY', value: 'KY' },
  { text: 'LA', value: 'LA' },
  { text: 'ME', value: 'ME' },
  { text: 'MD', value: 'MD' },
  { text: 'MA', value: 'MA' },
  { text: 'MI', value: 'MI' },
  { text: 'MN', value: 'MN' },
  { text: 'MS', value: 'MS' },
  { text: 'MO', value: 'MO' },
  { text: 'MT', value: 'MT' },
  { text: 'NE', value: 'NE' },
  { text: 'NV', value: 'NV' },
  { text: 'NH', value: 'NH' },
  { text: 'NJ', value: 'NJ' },
  { text: 'NM', value: 'NM' },
  { text: 'NY', value: 'NY' },
  { text: 'NC', value: 'NC' },
  { text: 'ND', value: 'ND' },
  { text: 'OH', value: 'OH' },
  { text: 'OK', value: 'OK' },
  { text: 'OR', value: 'OR' },
  { text: 'PA', value: 'PA' },
  { text: 'RI', value: 'RI' },
  { text: 'SC', value: 'SC' },
  { text: 'SD', value: 'SD' },
  { text: 'TN', value: 'TN' },
  { text: 'TX', value: 'TX' },
  { text: 'UT', value: 'UT' },
  { text: 'VT', value: 'VT' },
  { text: 'VA', value: 'VA' },
  { text: 'WA', value: 'WA' },
  { text: 'WV', value: 'WV' },
  { text: 'WI', value: 'WI' },
  { text: 'WY', value: 'WY' }
]

export const CASH_CALL_CLAIM_PROVINCE_OPTIONS = [
  { text: 'AB', value: 'AB' }, // Alberta
  { text: 'BC', value: 'BC' }, // British Columbia
  { text: 'MB', value: 'MB' }, // Manitoba
  { text: 'NB', value: 'NB' }, // New Brunswick
  { text: 'NL', value: 'NL' }, // Newfoundland and Labrador
  { text: 'NS', value: 'NS' }, // Nova Scotia
  { text: 'NT', value: 'NT' }, // Northwest Territories
  { text: 'NU', value: 'NU' }, // Nunavut
  { text: 'ON', value: 'ON' }, // Ontario
  { text: 'PE', value: 'PE' }, // Prince Edward Island
  { text: 'QC', value: 'QC' }, // Quebec
  { text: 'SK', value: 'SK' }, // Saskatchewan
  { text: 'YT', value: 'YT' }  // Yukon
]

export const CASH_CALL_SANCTIONS_CHECK_OPTIONS = [
  { text: 'Completed', value: 'Completed' },
  { text: 'Not Completed', value: 'Not Completed' }
]

export const CASH_CALL_STATUS_OPTIONS = [
  { text: 'All', value: 'All' },
  { text: 'Draft', value: 'DRAFT' },
  { text: 'Saved', value: 'SAVED' },
  { text: 'Submitted', value: 'SUBMITTED'},
  { text: 'Paid', value: 'PAID'},
  { text: 'Partially Paid', value: 'PARTIALLY PAID'},
  { text: 'Rejected', value: 'REJECTED'},
  { text: 'Cancelled', value: 'CANCELLED'},
]
